var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndefiniteMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,5c-0.208313,0-0.4104614,0.0245361-0.6171875,0.03125l3.3242188-3.3242188l-1.4140625-1.4140625l-5,5 c-0.390625,0.390625-0.390625,1.0234375,0,1.4140625l5,5l1.4140625-1.4140625l-3.2647095-3.2647095 C23.6290894,7.0221558,23.8117676,7,24,7c9.3740234,0,17,7.6259766,17,17c0,7.2597656-4.5825195,13.4534912-11,15.8859863 v2.1277466C37.5422363,39.4943237,43,32.37854,43,24C43,13.5234375,34.4765625,5,24,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7070312,36.2929688l-1.4140625,1.4140625l3.2647095,3.2647095C24.3709106,40.9778442,24.1882324,41,24,41 c-9.3740234,0-17-7.6259766-17-17c0-7.2597656,4.5825195-13.4534912,11-15.8859863V5.9862671C10.4577637,8.5056763,5,15.62146,5,24 c0,10.4765625,8.5234375,19,19,19c0.208313,0,0.4104614-0.0245361,0.6171875-0.03125l-3.3242188,3.3242188l1.4140625,1.4140625l5-5 c0.390625-0.390625,0.390625-1.0234375,0-1.4140625L22.7070312,36.2929688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,16v8c0,1.1025391,0.8974609,2,2,2h10v-2H24v-8H22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndefiniteMedium);
export default __webpack_public_path__ + "static/media/indefinite--medium.a254f8c11fb92262bfb0ecc11223a188.svg";
export { ForwardRef as ReactComponent };